import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import { CONCRETE_RESIN_ADMIN_URL } from "./concreteResinAdminUrl";
import {
  InsertChemicalAnchorMappingBody,
  SearchChemicalAnchorMappingsResponse,
  UpdateChemicalAnchorMappingBody,
} from "./types/chemicalAnchorMappings";
import { concreteResinSettingsUrl } from "./useSettings";

export const useChemicalAnchorMappingsApi = () => {
  // The calculations' settings nest the mappings in their anchors.
  const crud = createAdminCrudApi<
    SearchChemicalAnchorMappingsResponse,
    InsertChemicalAnchorMappingBody,
    UpdateChemicalAnchorMappingBody
  >(useApi(), CONCRETE_RESIN_ADMIN_URL, "anchor-mappings", [concreteResinSettingsUrl]);

  return {
    useChemicalAnchorMappings: crud.useSearch,
    insertChemicalAnchorMapping: crud.insert,
    updateChemicalAnchorMapping: crud.update,
    deleteChemicalAnchorMapping: crud.remove,
  };
};

export default useChemicalAnchorMappingsApi;
